import { RegistrationSuccessComponent } from './components/registration-form/registration-success/registration-success.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutusComponent } from './components/aboutus/aboutus.component';
import { BlogComponent } from './components/blog/blog.component';
import { ComingsoonComponent } from './components/comingsoon/comingsoon.component';
import { ContactSalesComponent } from './components/contact-sales/contact-sales.component';
import { ContactuspageComponent } from './components/contactuspage/contactuspage.component';
import {HomePageComponent} from './components/home-page/home-page.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { RegistrationFormComponent } from './components/registration-form/registration-form.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { TermsConditionsComponent } from './termsConditions/termsConditions.component';

const routes: Routes = [
  {path:'pricing123', component: PricingComponent},
  {path:'comingsoon', component: ComingsoonComponent},
  {path:'aboutus', component: AboutusComponent},
  {path:'contactus', component: ContactuspageComponent},
  {path:'blog', component: BlogComponent},
  {path:'registration', component: RegistrationFormComponent},
  {path:'registrationsuccess', component: RegistrationSuccessComponent},
  {path:'privacy', component: PrivacyComponent},
  {path:'terms-and-conditions', component: TermsConditionsComponent},
  {path:'sales', component: ContactSalesComponent},
  {path:':type', component: HomePageComponent},

  {path:'**', component: HomePageComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
